import { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";

const sources = [
  { value: "social_media", label: "Social Media (Instagram, Facebook, TikTok)" },
  { value: "youtube", label: "YouTube" },
  { value: "google_search", label: "Google Search" },
  { value: "friend", label: "Friend or Family Recommendation" },
  { value: "event", label: "Event or Exhibition" },
  { value: "other", label: "Other" },
];

export function WelcomePopup() {
  const [open, setOpen] = useState(false);
  const [selectedSource, setSelectedSource] = useState("");
  const [otherText, setOtherText] = useState("");

  useEffect(() => {
    const hasSeenPopup = localStorage.getItem("beex_welcome_popup_seen");
    if (!hasSeenPopup) {
      const timer = setTimeout(() => setOpen(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleSubmit = () => {
    const response = selectedSource === "other" ? otherText : selectedSource;
    console.log("User found BeeX via:", response);
    localStorage.setItem("beex_welcome_popup_seen", "true");
    localStorage.setItem("beex_source", response);
    setOpen(false);
  };

  const handleSkip = () => {
    localStorage.setItem("beex_welcome_popup_seen", "true");
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold">Welcome to BeeX Performance!</DialogTitle>
          <DialogDescription className="text-muted-foreground">
            We'd love to know how you discovered us.
          </DialogDescription>
        </DialogHeader>
        
        <div className="py-4">
          <RadioGroup value={selectedSource} onValueChange={setSelectedSource}>
            {sources.map((source) => (
              <div key={source.value} className="flex items-center space-x-3 py-2">
                <RadioGroupItem value={source.value} id={source.value} />
                <Label htmlFor={source.value} className="cursor-pointer">
                  {source.label}
                </Label>
              </div>
            ))}
          </RadioGroup>
          
          {selectedSource === "other" && (
            <Input
              placeholder="Please specify..."
              value={otherText}
              onChange={(e) => setOtherText(e.target.value)}
              className="mt-3"
            />
          )}
        </div>

        <div className="flex gap-3 justify-end">
          <Button variant="ghost" onClick={handleSkip}>
            Skip
          </Button>
          <Button 
            onClick={handleSubmit} 
            disabled={!selectedSource || (selectedSource === "other" && !otherText.trim())}
          >
            Submit
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
